<template lang="pug">
div.padding
    div.row
        .col-md-12
            h5.m-b-md._300 Role & Permissions
        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="associated_permissions", slot-scope="props")
                        span(v-if="props.row.name == 'inventory_admin'") All Permission
                        span(v-else) {{ props.row.permissions.length }} {{ props.row.permissions.length > 1 ? 'Permissions' : 'Permission' }}

</template>

<script>
import { Event } from '@js/event-bus';

export default {
    data() {
        var that = this;

        return {
            tableName: 'VUETABLE_ROLES',
            columns: ['display_name', 'associated_permissions'],
            options: {
                headings: {
                    display_name: 'Name',
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showPermission,
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('role_permissions.index');
        },
    },

    created() {
        Event.$on('permission-saved', () => this.$refs.datatable.getData());
    },

    methods: {
        showPermission(row) {
            this.$router.push(`/${row.name}`);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/role_permissions/role-list.vue